import { combineReducers } from 'redux';

import {
  INVENTORY_ADVANCED_TRANSFER_SET_TRANSFERS,
  INVENTORY_TRANSFER_SET_FORM_TYPE,
  INVENTORY_TRANSFER_SET_TRANSFER_TYPE,
  ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_ITEM_TRANSFER,
  ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_INGREDIENT_TRANSFER,
  ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_ITEM_TRANSFER,
  ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_INGREDIENT_TRANSFER,
  INVENTORY_TRANSFER_ERROR_ITEM,
  ADVANCE_INVENTORY_TRANSFER_TAB_PERMISSION,
} from '../../actions/inventory/transfer/constants';
import createReducer from '../../utils/createReducer';

import type {
  AdvancedTransferSetFormTypeAction,
  AdvancedTransferSetListAction,
  DetailItemTransferAction,
  DetailIngredientTransferAction,
  PartialItemsTransferAction,
  PartialIngredientsTransferAction,
} from '../../actions/inventory/transfer/types';
import type {
  Data as ItemTransferData,
  Activity as ItemTransferActivity,
} from '../../api/inventory/advancedTransfer/types/common.types';
import type {
  Data as IngredientTransferData,
  Activity as IngredientTransferActivity,
} from '../../api/ingredientInventory/advancedTransfer/types/responses';
import type { SimplifiedCreateReducerHandlers } from '../../types/common';
import type { FormType, TAB_TYPE } from '../../types/actionBars';
import type { ActionBarTransferTab, TransferTab } from './types';

const DEFAULT_TRANSFER_TAB: ActionBarTransferTab = {
  data: [],
  paging: {
    start: '',
    end: '',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    per_page: 50,
  },
  redDot: 0,
};

const advancedInventorySettings = createReducer<TransferTab>(
  {
    ALL: DEFAULT_TRANSFER_TAB,
    APPROVAL: DEFAULT_TRANSFER_TAB,
    SHIPMENT: DEFAULT_TRANSFER_TAB,
    FULFILLMENT: DEFAULT_TRANSFER_TAB,
    COMPLETED: DEFAULT_TRANSFER_TAB,
    REJECTED: DEFAULT_TRANSFER_TAB,
  },
  {
    [INVENTORY_ADVANCED_TRANSFER_SET_TRANSFERS]: (
      draft,
      { payload }: AdvancedTransferSetListAction
    ) => ({
      ...draft,
      ...payload!.data,
    }),
  } as SimplifiedCreateReducerHandlers<
    TransferTab,
    AdvancedTransferSetListAction
  >
);

const detailItemTransfer = createReducer<ItemTransferData | null>(null, {
  [ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_ITEM_TRANSFER]: (
    draft,
    { payload }: DetailItemTransferAction
  ) => payload!.data,
} as SimplifiedCreateReducerHandlers<ItemTransferData | null, DetailItemTransferAction>);

const detailIngredientTransfer = createReducer<IngredientTransferData | null>(
  null,
  {
    [ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_INGREDIENT_TRANSFER]: (
      draft,
      { payload }: DetailIngredientTransferAction
    ) => payload!.data,
  } as SimplifiedCreateReducerHandlers<
    IngredientTransferData | null,
    DetailIngredientTransferAction
  >
);

const partialItemTransfer = createReducer<ItemTransferActivity[]>([], {
  [ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_ITEM_TRANSFER]: (
    draft,
    handler: PartialItemsTransferAction
  ) => handler.payload!.data,
} as SimplifiedCreateReducerHandlers<ItemTransferActivity[], PartialItemsTransferAction>);

const partialIngredientTransfer = createReducer<IngredientTransferActivity[]>(
  [],
  {
    [ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_INGREDIENT_TRANSFER]: (
      draft,
      { payload }: PartialIngredientsTransferAction
    ) => payload!.data as any,
  } as SimplifiedCreateReducerHandlers<
    IngredientTransferActivity[],
    PartialIngredientsTransferAction
  >
);

const transfersType = createReducer<TAB_TYPE>('ALL', {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_TRANSFER_SET_TRANSFER_TYPE]: (draft, { payload }) => payload.type,
});

const formType = createReducer<FormType>('VIEW', {
  [INVENTORY_TRANSFER_SET_FORM_TYPE]: (
    draft,
    { payload }: AdvancedTransferSetFormTypeAction
  ) => payload!.type,
} as SimplifiedCreateReducerHandlers<FormType, AdvancedTransferSetFormTypeAction>);

const isErrorGetItem = createReducer(false, {
  [INVENTORY_TRANSFER_ERROR_ITEM]: (draft, { payload }) => payload,
});

const tabPermissions = createReducer([], {
  [ADVANCE_INVENTORY_TRANSFER_TAB_PERMISSION]: (draft, { payload }) => payload,
});

export default combineReducers({
  tabData: advancedInventorySettings,
  formType,
  transfersType,
  detailItemTransfer,
  detailIngredientTransfer,
  partialItemTransfer,
  partialIngredientTransfer,
  isErrorGetItem,
  tabPermissions,
});
